export default "__VITE_ASSET__DwFob3TW__"